import { motion } from "framer-motion";

export default function OpsPromise() {
  return (
    <section data-testid="section-promise" className="relative bg-[#F1ECE0] text-[#1A2E4A] border-t border-[#1A2E4A]/10 overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-20 md:py-28 text-center">
        <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#1A2E4A] mb-8 inline-flex items-center gap-2">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#B8E024]" />
          Our promise
        </div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="font-editorial text-3xl md:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-[#1A2E4A] max-w-4xl mx-auto"
        >
          We don&apos;t simply build dashboards.
          <br />
          <span className="italic">
            We build Operational Intelligence solutions that help organisations understand what
            is happening within their business, improve performance, and make decisions with
            <span className="text-[#B8E024]"> confidence.</span>
          </span>
        </motion.p>
      </div>
    </section>
  );
}
